import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { isLogin } = useSelector((state) => state.user);

  return isLogin ? children : <Navigate to="/" />;
};

export default PrivateRoute;
